import type { OnboardingModalStep } from "../types";

export const TOTAL_STEPPER_SEGMENTS = 6;

/**
 * Maps modal step index to stepper segment (1-based).
 * Step 0 (Welcome) has no stepper. Steps 1-6 map to segments 1-6.
 */
export const getStepperSegment = (step: OnboardingModalStep): number => {
  if (step === 0) return 0;
  return step;
};

export const stepConfig: Record<
  OnboardingModalStep,
  { ctaLabel: string; showBack: boolean; fullWidthCta: boolean }
> = {
  0: { ctaLabel: "Get started", showBack: false, fullWidthCta: true },
  1: { ctaLabel: "Continue", showBack: true, fullWidthCta: false },
  2: { ctaLabel: "Continue", showBack: true, fullWidthCta: false },
  3: { ctaLabel: "Continue", showBack: true, fullWidthCta: false },
  4: { ctaLabel: "Continue", showBack: true, fullWidthCta: false },
  5: { ctaLabel: "Continue", showBack: true, fullWidthCta: false },
  6: {
    ctaLabel: "Start exploring DeskDay",
    showBack: true,
    fullWidthCta: false,
  },
};
